module.exports = __webpack_public_path__ + "img/editorial_plan.06d4d7e0.png";